import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import PremiumBadgeIcon from 'components/Icons/PremiumBadgeIcon';
import CamHighlightsTimestampIcon from 'components/Icons/CamHighlightsTimestampIcon';

import styles from './EndOfReelsCTA.module.scss';

interface EndOfReelsCTAProps {
  upgradeUrl: string;
  onReplayClick: () => void;
}

const EndOfReelsCTA = ({ upgradeUrl, onReplayClick }: EndOfReelsCTAProps) => {
  return (
    <div className={styles.endOfReelsCTA}>
      <div className={styles.endOfReelsCTAContent}>
        <PremiumBadgeIcon className={styles.premiumBadgeIcon} height="46px" width="36px" />
        <Typography variant="title2" color="white">
          Upgrade to access the live cam stream
        </Typography>
        <Typography variant="body1" color="white">
          Start your free trial to get an ocean view of anywhere, from anywhere.
        </Typography>
        <Button
          className={styles.endOfReelsCTAButton}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          href={upgradeUrl}
          size="medium"
          variant="primary"
        >
          Upgrade to Premium
        </Button>
        <Button
          className={styles.replayReelsButton}
          variant="text"
          size="medium"
          onClick={onReplayClick}
        >
          <CamHighlightsTimestampIcon />
          <Typography className={styles.replayReelsButtonText} variant="callout1" color="white">
            Replay Highlights
          </Typography>
        </Button>
      </div>
    </div>
  );
};

export default EndOfReelsCTA;
